import getFulfilmentType, { FULFILMENT_TYPE } from "../../getFulfilmentType";

const shouldAddFlexibleSalesChannels = (sourceId, sellerId) => {
  const fulfilmentType = getFulfilmentType({ sourceId, sellerId });

  return (
    fulfilmentType === FULFILMENT_TYPE.AFS ||
    fulfilmentType === FULFILMENT_TYPE.PARTNER_FULFILS
  );
};

const buildItemObject = ({
  productId,
  productCode,
  variantId,
  title,
  brand,
  price,
  colour,
  variants,
  index
}) => {
  const getSize = () => {
    const selectedVariant = variants?.find(({ id }) => id === variantId);

    return selectedVariant ? selectedVariant.size : undefined;
  };

  const { xrp, current } = price;

  return {
    productId: productId ? String(productId) : undefined,
    productCode: String(productCode),
    variantId: variantId ? String(variantId) : undefined,
    item_name: title,
    index: index + 1,
    item_brand: brand,
    price: xrp?.value || undefined,
    priceLocalCurrency: current.value,
    quantity: 1,
    size: getSize(),
    item_variant: colour || undefined,
    google_business_vertical: "retail"
  };
};

const itemDataTemplate = (
  {
    productId,
    productCode,
    variantId,
    brand,
    colour,
    title,
    price,
    variants,
    source,
    seller
  },
  index = 0
) => {
  const item = buildItemObject({
    productId,
    productCode,
    variantId,
    brand,
    colour,
    title,
    price,
    variants,
    index
  });

  const sourceId = source?.id ?? null;
  const sellerId = seller?.id ?? null;

  if (shouldAddFlexibleSalesChannels(sourceId, sellerId)) {
    item.flexibleSalesChannels = {
      sourceId,
      sellerId
    };
  }

  return item;
};

export default itemDataTemplate;
